import React, { Component } from 'react';
import PropTypes from 'prop-types';

import FilterTableProvider from '@container/FilterTableProvider';

import { resourceTableColumns } from 'utils/recordHelpers'

const propTypes = {
  records: PropTypes.array.isRequired,
  totalPages: PropTypes.number.isRequired,
  newURL: PropTypes.string,
  // filterURL:  PropTypes.string.isRequired,
};

const ResourceTableIndex = (props) => {
  const primaryAction = props.newURL ? { content: 'Agregar Tabla', url: props.newURL } : null;

  return (
    <FilterTableProvider
      pageProps={{
        title: I18n.t("activerecord.models.resource_table.other"),
        primaryAction: primaryAction,
      }}
      paramsName="filters"
      filterURL={ props.filterURL }
      resourceTableProps={{
        itemURL: "/resource_tables",
        urlAction: "edit"
      }}

      initialRecords={ props.records }
      columnsInfo={ resourceTableColumns }
      
      initialTotalPages={ props.totalPages }
      legacy={ false }
    >
    </FilterTableProvider>
  );
}

ResourceTableIndex.propTypes = propTypes;


export default ResourceTableIndex;
